export const Constants = {
  TAG_NAME: 'pop-purchases-and-sales-table-component',
  NAME_COLUMN_HEADER: 'Issuer',
  PREV_QUARTER_PORTFOLIO_WEIGHT_COLUMN_HEADER:
    'Previous quarter % of portfolio',
  PORTFOLIO_WEIGHT_COLUMN_HEADER: '% of portfolio',
  CHANGE_COLUMN_HEADER: '% change from previous quarter',
  SECTOR_COLUMN_HEADER: 'Sector',
  EMPTY_CELL_VALUE: 'N/A',
} as const;
